module.exports = __webpack_public_path__ + "img/dz.cbc327cb.svg";